import { DocumentSelectorWrapper } from "cms/documents/document-selector/document-selector-wrapper";
import { SettingsFormatEdit } from "cms/fields/layout/controls/settings-format";
import { SettingsStyleEdit } from "cms/fields/layout/controls/settings-style";
import { SettingsTargetEdit } from "cms/fields/layout/controls/settings-targets";
import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import DisplaySettingsWrapper from "cms/fields/layout/display-settings-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { useAuth } from "cms/auth/hooks/use-auth";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { isStringNotEmpty } from "utils/empty-exists";
import debounce from "lodash.debounce";

const DocumentFieldItemEdit = () => {

    const { t } = useTranslation();
    const { token } = useAuth();

    const {
        type,
        name,
        index,
        value,
        settings,
        updateListItem,
        disabled = false,
        // defaultImpl
    } = useContext(ListItemContext);

    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { styleOptions, formatOptions, options: schemaOptions } = schemaSettings || {};

    const [document, setDocument] = useState();
    const [itemLocalState, setItemLocalState] = useState({ value, settings });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 500),
        [updateListItem]
    );
    const onDocumentChange = (document) => {
        const { guid = "" } = document || {}; // when removing set value to ''
        setDocument(document);
        const updatedState = {
            ...itemLocalState,
            value: guid
        };
        setItemLocalState(updatedState);
        update(updatedState, index);
    };

    const onDocumentChoose = (document) => {
        const { guid = "" } = document || {}; // when removing set value to ''
        setDocument(document);
        const updatedState = {
            ...itemLocalState,
            value: guid
        };
        setItemLocalState(updatedState);
        update(updatedState, index);
    };
    const onDocumentRemove = () => {
        setDocument(undefined);
        const updatedState = {
            ...itemLocalState,
            value: undefined
        };
        setItemLocalState(updatedState);
        update(updatedState, index);
    };

    useEffect(() => {
        async function fetchData () {
            const document_guid = itemLocalState.value;
            if (isStringNotEmpty(document_guid)) {
                const document = await SimpliCityAdminSDK.documents.findOne(token, document_guid);
                if (document && document.guid) {
                    setDocument(document);
                } else {
                    setDocument(undefined);
                }
            }
        }
        if (itemLocalState.value) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemLocalState.value]);

    return (
        <>
            <div className='simplicity-composer-field-primary-layout'>

                <div className='simplicity-composer-field-primary'>
                    <div className='simplicity-document-editor'>
                        <div className='simplicity-document-editor-view'>
                            <div className="document-display" style={{
                                display: "flex", flexDirection: "column"
                                // flex: '1', border: `1px solid #CFCFCF`, padding: 12,
                            }}
                            >
                                {/*  Edit Document Value  */}
                                <DocumentSelectorWrapper
                                    document={document}
                                    setDocument={setDocument}
                                    onChooseDocumentHandler={onDocumentChoose}
                                    onDocumentChange={onDocumentChange}
                                    onDocumentRemove={onDocumentRemove}
                                    // disabled={disabled}
                                />
                            </div>
                        </div>
                    </div>
                </div>


                <DisplaySettingsWrapper>
                    {/*  Reads from schema options.styleOptions */}
                    {/*  records selection as value settings.style */}
                    <SettingsStyleEdit
                        type={type}
                        name={name}
                        label={t("commons.displayStyle")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        styleOptions={styleOptions}
                        selected={itemLocalState?.settings?.style}
                        index={index}
                        update={update}
                    />
                    {/*  Reads from schema options.formatOptions */}
                    {/*  records selection as value settings.format */}
                    <SettingsFormatEdit
                        type={type}
                        name={name}
                        label={t("commons.displayAs")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        formatOptions={formatOptions}
                        selected={itemLocalState?.settings?.format}
                        index={index}
                        update={update}
                    />
                    {/*  Reads from schema options.targets */}
                    {/*  records selection as value settings.options.openIn */}
                    <SettingsTargetEdit
                        type={type}
                        name={name}
                        label={t("commons.openIn")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        schemaOptions={schemaOptions}
                        selected={itemLocalState?.settings?.options?.openIn}
                        index={index}
                        update={update}
                    />
                </DisplaySettingsWrapper>
            </div>
        </>
    );
};
DocumentFieldItemEdit.displayName = "DocumentFieldItemEdit";
export { DocumentFieldItemEdit };
